import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import doc                 from '@widesk-core/decorators/doc';

export default class DaisukiContentModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'contentUrn': Urn;
		'type': id;
		'contentId': string;
		'tags[serviceUrn][tagReference]': id;
	};

	static get path(): string {
		return 'daisuki_contents/{?id}';
	}

	@doc.string declare contentUrn: string;
	@doc.string declare type: DaisukiContentType;
	@doc.number declare contentId: number;
	@doc.number declare count: number;
	@doc.string declare createdBy: string;
	@doc.string declare updatedBy: string;
	@doc.date declare createdAt: Dayjs;
	@doc.date declare updatedAt: Dayjs;
}